import { FAQuestionHeading } from "../../../../src/data/articles/frequently-asked-questions-about-cube/FAQuestionHeading.tsx";
import * as React from 'react';
export default {
  FAQuestionHeading,
  React
};